export default function initHighlights() {
    const section = document.querySelector('.c-highlights');
    const mainSlider = document.querySelector('.c-highlights__main-slider');
    const navSlider = document.querySelector('.c-highlights__nav-slider');

    if (!mainSlider || !navSlider) return;

    const highlightsNav = new Swiper(navSlider, {
        slidesPerView: 3,
        spaceBetween: 7,
        freeMode: true,
        watchSlidesProgress: true,
        breakpoints: {
            992: {
                spaceBetween: 20,
            }
        },
    });

    const highlightsMain = new Swiper(mainSlider, {
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        autoHeight: true,
        pagination: {
            el: '.c-highlights__progress',
            type: 'progressbar',
        },
        thumbs: {
            swiper: highlightsNav
        },
        a11y: {
            prevSlideMessage: 'Destaque anterior',
            nextSlideMessage: 'Próximo destaque',
        }
    });

    highlightsMain.on('slideChange', function () {
        if (!section) return;

        const rect = section.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const targetY = rect.top + scrollTop - 50;

        window.scrollTo({
            top: targetY,
            behavior: 'smooth'
        });
    });

    highlightsNav.on('click', function () {
        if (!section) return;

        const rect = section.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const targetY = rect.top + scrollTop - 50;

        window.scrollTo({
            top: targetY,
            behavior: 'smooth'
        });
    });
}